import React from "react";
import { Animated, Platform, StyleProp, StyleSheet, TextStyle, View, ViewStyle } from "react-native";
import SVG_Svg, { GProps, PathProps, G as SVG_G, Path as SVG_Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"> <desc id="IMP.BLUE">{"#Vector":{"type":"SELECTOR","constraint":"none","width":20,"height":20},"transforms":{},"tProps":{"type":"PROPS","CancelIcon?":"tButtonProps","onAnimationComplete?":"() => void"},"#CancelIcon":{"type":"SELECTOR","touchableOpacity":{"onPress":"props?.CancelIcon?.onPress","animation":"touchableOpacity"},"constraint":"none","width":20,"height":20}}</desc>
 * <g id="CancelIcon">
 * <rect width="20" height="20" fill="white"/>
 * <g id="Vector">
 * <path fill-rule="evenodd" clip-rule="evenodd" d="M18.4615 20L0 1.11411L1.08785 0.00124971L19.5494 18.8871L18.4615 20Z" fill="#A9A9A9"/>
 * <path fill-rule="evenodd" clip-rule="evenodd" d="M20 1.11286L1.5385 19.9988L0.450648 18.8859L18.9121 0L20 1.11286Z" fill="#A9A9A9"/>
 * </g>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#Vector": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 20,
 * 		"height": 20
 * 	},
 * 	"transforms": {},
 * 	"tProps": {
 * 		"type": "PROPS",
 * 		"CancelIcon?": "tButtonProps",
 * 		"onAnimationComplete?": "() => void"
 * 	},
 * 	"#CancelIcon": {
 * 		"type": "SELECTOR",
 * 		"touchableOpacity": {
 * 			"onPress": "props?.CancelIcon?.onPress",
 * 			"animation": "touchableOpacity"
 * 		},
 * 		"constraint": "none",
 * 		"width": 20,
 * 		"height": 20
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  CancelIcon?: tButtonProps;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Button Prop Types */

type tButtonProps = {
  onPress: () => void;
} & GProps;
/***/

/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const CancelIcon = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  CancelIcon?: tButtonProps;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    style = {
      width: 20,
      height: 20,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    svgRef,
  } = props;
  // const kRenderInstanceID = Math.random().toString().replace(".", "");
  /** Component Internal State */

  const [buttonState, setButtonState] = React.useState<{
    CancelIconButtonOpacity: number;
  }>({
    CancelIconButtonOpacity: 1,
  });
  /** End Custom React-Hooks */

  /** Button Wrapper */
  // #region CancelIcon Button Handlers
  const { CancelIcon: CancelIcon2 } = props;
  const { onPress: CancelIconOnPress, ...CancelIconProps } = CancelIcon2 ?? {};

  const CancelIconButtonPressInFunction = () => 0;

  const CancelIconButtonPressOutFunction = CancelIconOnPress;

  const CancelIconButtonActive = (callback?: () => void) => {
    setButtonState({ ...buttonState, CancelIconButtonOpacity: 0.2 });

    if (callback) {
      callback();
    }
  };

  const CancelIconButtonInactive = (callback?: () => void) => {
    setButtonState({ ...buttonState, CancelIconButtonOpacity: 1 });

    if (callback) {
      callback();
    }
  };

  const CancelIconOnPressIn = () => {
    CancelIconButtonActive(CancelIconButtonPressInFunction);
  };

  const CancelIconOnPressOut = () => {
    CancelIconButtonInactive(CancelIconButtonPressOutFunction);
  };
  /***/
  // #endregion

  /** End Button Wrapper */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg fill="none" id="svg_root" ref={svgRef} {...props} style={svgStyle}>
          <G
            id="CancelIcon"
            opacity={buttonState.CancelIconButtonOpacity}
            onMouseDown={CancelIconOnPressIn}
            onMouseUp={CancelIconOnPressOut}
            cursor="pointer"
            {...CancelIconProps}
          >
            <Path
              fill="#FFFFFF05"
              id="CancelIcon_elem0"
              d="M0 0 H20 a0,0 0 0 1 0,0 V20 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V0 a0,0 0 0 1 0,-0z"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
            />
            <Svg preserveAspectRatio="none" viewBox="0 0 20 20">
              <G id="Vector">
                <Path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M18.4615 20L0 1.11411L1.08785 0.00124971L19.5494 18.8871L18.4615 20Z"
                  fill="#A9A9A9"
                  id="Vector_elem0"
                  strokeWidth="1"
                  vectorEffect="non-scaling-stroke"
                />
                <Path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M20 1.11286L1.5385 19.9988L0.450648 18.8859L18.9121 0L20 1.11286Z"
                  fill="#A9A9A9"
                  id="Vector_elem1"
                  strokeWidth="1"
                  vectorEffect="non-scaling-stroke"
                />
              </G>
            </Svg>
          </G>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="none"
        viewBox="0 0 20 20"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          fill="white"
          id="CancelIcon_elem0"
          d="M0 0 H20 a0,0 0 0 1 0,0 V20 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V0 a0,0 0 0 1 0,-0z"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="none"
        viewBox="0 0 20 20"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <G id="Vector">
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.4615 20L0 1.11411L1.08785 0.00124971L19.5494 18.8871L18.4615 20Z"
            fill="#A9A9A9"
            id="Vector_elem0"
            strokeWidth="1"
            vectorEffect="non-scaling-stroke"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 1.11286L1.5385 19.9988L0.450648 18.8859L18.9121 0L20 1.11286Z"
            fill="#A9A9A9"
            id="Vector_elem1"
            strokeWidth="1"
            vectorEffect="non-scaling-stroke"
          />
        </G>
      </Svg>
    </View>
  );
};
/***/

export default React.memo(CancelIcon);
